import { ReactNode } from 'react';

import { GnbRedDotTypes } from '@flipster/apis/v1/red-dot/types';
import { useAuth } from '@flipster/features/src/shared/auth/state';
import { StatusBadge } from '@flipster/react/design-system';
import { Styles } from '@flipster/styled-system/css';

import { useRedDot } from '@web/hooks/useRedDot';

import { useUpdateRedDotMutation } from './useUpdateRedDotMutation';

interface Props {
  redDotKey?: GnbRedDotTypes;
  children: ReactNode;
  css?: Styles;
}
const RedDot = ({ redDotKey, children, css: cssProp }: Props) => {
  const { data: redDot } = useRedDot();
  const { isCookieLoggedIn } = useAuth();
  const { mutateAsync: updateRedDot } = useUpdateRedDotMutation();

  return (
    <StatusBadge
      css={cssProp}
      visible={Boolean(redDotKey != null && redDot?.gnb.includes(redDotKey))}
      positionType='text'
      onClick={() => {
        if (redDotKey != null && isCookieLoggedIn) updateRedDot({ gnb: redDotKey });
      }}
    >
      {children}
    </StatusBadge>
  );
};

export default RedDot;
